<template lang="pug">
    div.expandCard
        table
            // Duration
            tr
                td {{ $t('fields.duration') }}
                td {{ item.duration }}

            // Duration in months'
            tr
                td {{ $t('fields.durationInMonths') }}
                td {{ item.duration_in_months}}

            // Discount off
            tr
                td {{ $t('fields.discountOff') }}
                td(v-if="item.percent_off") {{ `${item.percent_off}%`}}
                td(v-else) {{ `$${item.amount_off/100}`}}

            // Max redemptions
            tr
                td {{ $t('fields.maxRedemptions') }}
                td {{ item.max_redemptions }}

            // Times redeemed
            tr
                td {{ $t('fields.timesRedeemed') }}
                td {{ item.times_redeemed }}

            // Redeem by
            tr
                td {{ $t('fields.redeemBy') }}
                td {{ item.redeem_by | FormattedUnixDate }}

            // Valid
            tr
                td {{ $t('fields.valid') }}
                td {{ item.valid ? 'Yes' : 'No' }}
</template>

<script>
    import VueTypes from 'vue-types';
    import FormattedUnixDate from '~filters/FormattedUnixDate';

    export default {
        filters: {
            FormattedUnixDate
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            /**
             * Get title for business program
             * @param item
             * @returns {TranslateResult|VueI18n.TranslateResult|string|{custom: string, challenge: string}|{custom: string, challenge: string}}
             */
            getProgramTitle(item) {
                if (item.programTitle) {
                    return item.programTitle;
                }

                if (item.isCustomProgram) {
                    return this.$t('business.list.programTitle.custom');
                }

                if (item.isChallenge) {
                    return this.$t('business.list.programTitle.challenge');
                }

                return '';
            }
        }
    };
</script>
